<template>
  <LoadingWrapper :state="status">
    <SideBarLayoutContent>
      <template #top-bar>
        <div class="flex flex-row items-center gap-2">
          <BackButton
            backup-route-name="coachee"
            :params="{ id: ownerId }"
            :query="{ tab: 'coachee-objectives' }"
            icon="arrow_back"
            close
            class="mr-2 -ml-2"
          />
          <span v-if="coachee" class="text-headline-medium">{{
            memberFullName(coachee.member)
          }}</span>
          <BaseIcon v-if="coachee">chevron_right</BaseIcon>
          <h1 class="text-headline-medium grow">
            {{ $t('coaching.objectives.archived.title') }}
          </h1>
        </div>
      </template>

      <ul v-if="data.objectives.length > 0" class="mx-auto flex w-full max-w-3xl flex-col gap-2">
        <li v-for="objective in data.objectives" :key="objective.id">
          <ObjectiveItem
            :objective="objective"
            :feedback-topics="feedbackTopics"
            :feedback-topic="
              feedbackTopics.find((feedbackTopic) => feedbackTopic.id === objective.feedbackTopicId)
            "
          />
        </li>
      </ul>

      <EmptyPage
        v-else
        :title="$t('coaching.objectives.archived.empty.title')"
        :description="$t('coaching.objectives.archived.empty.description')"
        icon="archive"
      />
    </SideBarLayoutContent>
  </LoadingWrapper>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import ObjectiveItem from '@/core/components/objective/ObjectiveItem.vue'
  import BackButton from '@/core/components/BackButton.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { memberFullName } from '@/core/models/member/member-name'
  import { useCompleteFeedbackTopics } from '@/core/composables/use-complete-feedback-topics'
  import { useArchivedObjectives } from '@/core/composables/use-archived-objectives'
  import { useCoachee } from '../composables/useCoachee'

  const route = useRoute()
  const ownerId = computed(() => route.params.id as string)
  const { data, status } = useArchivedObjectives(ownerId)
  const { data: coachee } = useCoachee()
  const { data: topicsData } = useCompleteFeedbackTopics()

  const feedbackTopics = computed(() => topicsData.value?.feedbackTopics ?? [])
</script>
